// VIN decoder via NHTSA vPIC API (free, no key required)
// Same as Cook's Garage — works for trucks, trailers, all vehicles

const NHTSA_BASE = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues';

export async function decodeVIN(vin) {
  if (!vin || vin.length !== 17) return null;

  try {
    const res = await fetch(`${NHTSA_BASE}/${vin}?format=json`);
    if (!res.ok) return null;

    const data = await res.json();
    const r = data.Results?.[0];
    if (!r) return null;

    return {
      vin,
      year: parseInt(r.ModelYear) || null,
      make: r.Make || '',
      model: r.Model || '',
      trim: r.Trim || '',
      engine: [r.DisplacementL ? `${r.DisplacementL}L` : '', r.EngineCylinders ? `${r.EngineCylinders}cyl` : '', r.FuelTypePrimary || ''].filter(Boolean).join(' '),
      bodyClass: r.BodyClass || '',
      gvwr: r.GVWR || '',
      plantCity: r.PlantCity || '',
      plantCountry: r.PlantCountry || '',
      vehicleType: r.VehicleType || '',
      manufacturer: r.Manufacturer || '',
      driveType: r.DriveType || '',
      brakeSystem: r.BrakeSystemType || '',
      abs: r.ABS || '',
      esc: r.ESC || '',
      tractionControl: r.TractionControl || '',
      forwardCollisionWarning: r.ForwardCollisionWarning || '',
      automaticEmergencyBraking: r.AutomaticPedestrianAlertingSound || '',
      errorCode: r.ErrorCode || '0',
    };
  } catch (e) {
    console.warn('VIN decode failed:', e.message);
    return null;
  }
}
